function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Timeline(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 1c1.819 0 3.3 1.48 3.3 3.3 0 1.47-.968 2.72-2.3 3.145v1.354a3.306 3.306 0 012.3 3.145c0 1.47-.968 2.72-2.3 3.144v1.334a3.306 3.306 0 012.3 3.145c0 1.819-1.481 3.3-3.3 3.3a3.305 3.305 0 01-3.3-3.3c0-1.472.968-2.72 2.3-3.145v-1.333A3.307 3.307 0 012 11.944c0-1.472.968-2.72 2.3-3.145V7.445A3.307 3.307 0 012 4.3C2 2.48 3.48 1 5.3 1zm0 17.267a1.301 1.301 0 000 2.6 1.301 1.301 0 000-2.6zm14.888.32a1 1 0 110 2h-9.104a1 1 0 110-2h9.104zM5.3 10.644a1.301 1.301 0 000 2.6 1.301 1.301 0 000-2.6zm13.37.3a1 1 0 110 2h-7.586a1 1 0 110-2h7.587zM5.3 3a1.301 1.301 0 000 2.6 1.301 1.301 0 000-2.6zm14.888.3a1 1 0 110 2h-9.104a1 1 0 110-2h9.104z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoTimeline = /*#__PURE__*/React.memo(Timeline);
export default MemoTimeline;